import type { StrFn } from '@duda-co/booking/runtime';
import { localizationService } from '@shared-services/localization-service';
import { useCallback, useContext } from 'react';
import { useBookingContext } from '../Context';
import strings from '../strings';
import { shouldUsePaidBooking } from '../utils';
import { BookerStateContext } from './useRuntimeCalBookingState';

const BOOKER_SCOPE = 'ui.runtimessr.booker';

const str = localizationService.str;

export const useNativeBookerStr = (): StrFn => {
    const bookerContext = useBookingContext();
    const [bookingState] = useContext(BookerStateContext);

    const isPaidNextStep =
        shouldUsePaidBooking(bookerContext) &&
        !bookingState.rescheduleUid &&
        !bookingState.calEventData?.requiresBookerEmailVerification;

    return useCallback<StrFn>(
        (key, replacements) => {
            // The logic when we use another cta for submit button for paid bookings.
            if (key === 'confirm' && isPaidNextStep) {
                return str(strings.paidBookingNextStepButton);
            }

            const scopedKey = `${BOOKER_SCOPE}.${key}`;
            return str(scopedKey, replacements ?? undefined);
        },
        [isPaidNextStep]
    );
};
